// Boutons de la toolbar TinyMCE
import { I18nStrings } from '../i18n';
import {flipcardPluginName} from "@/components/tinyMce/plugins/flipcard/flipcardConstants";
export function registerToolbarButtons(editor: any, i18n: I18nStrings): void {
  editor.ui.registry.addButton(flipcardPluginName, {
    icon: 'flip-horizontally',
    tooltip: i18n.insertFlipCard,
    onAction: () => {
      const currentNode = editor.selection.getNode();
      const currentCard = currentNode.closest('.flipcard-container');

      if (currentCard) {
        // Si on est dans une card, créer un paragraphe après
        const p = editor.dom.create('p', {}, '<br>');
        currentCard.parentNode?.insertBefore(p, currentCard.nextSibling);
        editor.selection.setCursorLocation(p, 0);
      }

      editor.execCommand('flipcardInsert');
    }
  });

  // Icône personnalisée pour flip card (si nécessaire)
  editor.ui.registry.addIcon('flipcard-icon',
    '<svg width="24" height="24" viewBox="0 0 24 24">' +
    '<path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"/>' +
    '</svg>'
  );
}
